
import { useEffect } from 'react';
import Hero from './components/Hero';
import Listings from './components/Listings';
import YouTube from './components/YouTube';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import CompanyInfo from './components/CompanyInfo';
import Contact from './components/Contact';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://www.firm-kensetu.com';

function HomePageSEO() {
  useEffect(() => {
    const schemas = [
      {
        id: 'schema-local-business',
        data: {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "有限会社ファーム建設",
          "description": "創業43年の地域密着型工務店。不動産売買、リフォーム、空き家再生、譲渡型賃貸住宅など全国エリアでサービスを提供。",
          "url": SITE_URL,
          "logo": `${SITE_URL}/logo.png`,
          "image": "https://public.readdy.ai/ai/img_res/efb1c71b-5ccc-424c-beb1-a9c2b43967e2.png",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "港北区篠原町1187-6",
            "addressLocality": "横浜市",
            "addressRegion": "神奈川県",
            "postalCode": "222-0000",
            "addressCountry": "JP"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "35.4437",
            "longitude": "139.6380"
          },
          "foundingDate": "1972",
          "sameAs": [
            "https://www.facebook.com/firmkensetu",
            "https://twitter.com/mc20230616",
            "https://www.youtube.com/channel/UCtnjEv91bhwH_8152WLh_jg"
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "サービス一覧",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "不動産売買" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "リフォーム・リノベーション" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "不動産管理" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "空き家相談" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "マリアージュ賃貸（譲渡型賃貸住宅）" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "不動産コンサルティング" } }
            ]
          }
        }
      },
      {
        id: 'schema-webpage',
        data: {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "有限会社ファーム建設 | 不動産売買・リフォーム・空き家再生 | 神奈川県横浜市",
          "description": "有限会社ファーム建設は創業43年の地域密着型工務店です。神奈川県横浜市を拠点に、不動産売買、リフォーム・リノベーション、空き家再生、譲渡型賃貸住宅など、全国エリアでワンストップサービスを提供しています。",
          "url": SITE_URL,
          "inLanguage": "ja",
          "isPartOf": {
            "@type": "WebSite",
            "name": "有限会社ファーム建設",
            "url": SITE_URL
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "ホーム",
                "item": SITE_URL
              }
            ]
          }
        }
      },
      {
        id: 'schema-faq',
        data: {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "ファーム建設のファームってどういう意味?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "ファームという言葉はよく「牧場」やプロ野球の二軍チームの事をファームチームと呼びますが、弊社のファームの意味とは「堅実」という意味です。"
              }
            },
            {
              "@type": "Question",
              "name": "工務店とハウスメーカーの違いは?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "工務店は地場すなわちその土地の建築会社の事です。地域の皆様の住宅を守るのが工務店です。ハウスメーカーは地域にはございません。そこが大きな違いです。"
              }
            },
            {
              "@type": "Question",
              "name": "小さな事でもお願い出来ますか?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "勿論です。本当に小さな事でもいつでもお問い合わせお待ちしてます。40年以上の実績と経験がございます。出来ない事はございません。"
              }
            }
          ]
        }
      }
    ];

    schemas.forEach(({ id, data }) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement('script');
        el.id = id;
        (el as HTMLScriptElement).type = 'application/ld+json';
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    });

    return () => {
      schemas.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return null;
}

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HomePageSEO />
      <Hero />
      <Listings />
      <YouTube />
      <Services />
      <AboutUs />
      <CompanyInfo />
      <Contact />
    </div>
  );
}
